var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRollerCoaster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(1 0 0 -1 1557.068 -6409.493)",
    gradientUnits: "userSpaceOnUse",
    x1: -1513.502,
    x2: -1479.961,
    xlinkHref: "#lg1",
    y1: -6617.912,
    y2: -6617.912
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e5959",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(.707 -.707 .707 .707 2831.207 -1021.632)",
    gradientUnits: "userSpaceOnUse",
    x1: -2869.822,
    x2: -2894.181,
    xlinkHref: "#lg2",
    y1: -1048.782,
    y2: -1024.422
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(1 0 0 -1 1557.068 -6409.493)",
    gradientUnits: "userSpaceOnUse",
    x1: -1448.437,
    x2: -1414.895,
    xlinkHref: "#lg1",
    y1: -6619.912,
    y2: -6619.912
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.402,
    x2: 125.402,
    xlinkHref: "#lg2",
    y1: 189.337,
    y2: 139.521
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(.707 -.707 .707 .707 2831.207 -1021.632)",
    gradientUnits: "userSpaceOnUse",
    x1: -2823.813,
    x2: -2848.173,
    xlinkHref: "#lg2",
    y1: -1002.773,
    y2: -978.414
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(1 0 0 -1 1557.068 -6409.493)",
    gradientUnits: "userSpaceOnUse",
    x1: -1546.568,
    x2: -1513.027,
    xlinkHref: "#lg1",
    y1: -6756.329,
    y2: -6756.329
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(.707 -.707 .707 .707 2831.207 -1021.632)",
    gradientUnits: "userSpaceOnUse",
    x1: -3006.104,
    x2: -3030.463,
    xlinkHref: "#lg2",
    y1: -959.261,
    y2: -934.902
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(1 0 0 -1 1557.068 -6409.493)",
    gradientUnits: "userSpaceOnUse",
    x1: -1481.502,
    x2: -1447.961,
    xlinkHref: "#lg1",
    y1: -6777.579,
    y2: -6777.579
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.336,
    x2: 92.336,
    xlinkHref: "#lg2",
    y1: 367.116,
    y2: 300.927
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(.707 -.707 .707 .707 2831.207 -1021.632)",
    gradientUnits: "userSpaceOnUse",
    x1: -2960.096,
    x2: -2984.455,
    xlinkHref: "#lg2",
    y1: -913.253,
    y2: -888.893
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(1 0 0 -1 1557.068 -6409.493)",
    gradientUnits: "userSpaceOnUse",
    x1: -1416.437,
    x2: -1382.895,
    xlinkHref: "#lg1",
    y1: -6779.579,
    y2: -6779.579
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.402,
    x2: 157.402,
    xlinkHref: "#lg2",
    y1: 371.116,
    y2: 304.927
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(.707 -.707 .707 .707 2831.207 -1021.632)",
    gradientUnits: "userSpaceOnUse",
    x1: -2914.087,
    x2: -2938.447,
    xlinkHref: "#lg2",
    y1: -867.245,
    y2: -842.885
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(1 0 0 -1 1557.068 -6409.493)",
    gradientUnits: "userSpaceOnUse",
    x1: -1351.371,
    x2: -1317.83,
    xlinkHref: "#lg1",
    y1: -6758.579,
    y2: -6758.579
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.467,
    x2: 222.467,
    xlinkHref: "#lg2",
    y1: 329.116,
    y2: 262.927
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(.707 -.707 .707 .707 2831.207 -1021.632)",
    gradientUnits: "userSpaceOnUse",
    x1: -2868.079,
    x2: -2892.439,
    xlinkHref: "#lg2",
    y1: -821.236,
    y2: -796.877
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(1 0 0 -1 1557.068 -6409.493)",
    gradientUnits: "userSpaceOnUse",
    x1: -1286.305,
    x2: -1252.764,
    xlinkHref: "#lg1",
    y1: -6726.829,
    y2: -6726.829
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.533,
    x2: 287.533,
    xlinkHref: "#lg2",
    y1: 265.616,
    y2: 199.427
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(.707 -.707 .707 .707 2831.207 -1021.632)",
    gradientUnits: "userSpaceOnUse",
    x1: -2822.071,
    x2: -2846.43,
    xlinkHref: "#lg2",
    y1: -775.228,
    y2: -750.869
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(1 0 0 -1 1557.068 -6409.493)",
    gradientUnits: "userSpaceOnUse",
    x1: -1221.24,
    x2: -1187.699,
    xlinkHref: "#lg1",
    y1: -6693.829,
    y2: -6693.829
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 352.598,
    x2: 352.598,
    xlinkHref: "#lg2",
    y1: 199.616,
    y2: 133.427
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientTransform: "matrix(.707 -.707 .707 .707 2831.207 -1021.632)",
    gradientUnits: "userSpaceOnUse",
    x1: -2776.062,
    x2: -2800.422,
    xlinkHref: "#lg2",
    y1: -729.22,
    y2: -704.86
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientTransform: "matrix(1 0 0 -1 1557.068 -6409.493)",
    gradientUnits: "userSpaceOnUse",
    x1: -1156.174,
    x2: -1122.633,
    xlinkHref: "#lg1",
    y1: -6679.329,
    y2: -6679.329
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 417.664,
    x2: 417.664,
    xlinkHref: "#lg2",
    y1: 170.616,
    y2: 104.427
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientTransform: "matrix(.707 -.707 .707 .707 2831.207 -1021.632)",
    gradientUnits: "userSpaceOnUse",
    x1: -2730.054,
    x2: -2754.414,
    xlinkHref: "#lg2",
    y1: -683.212,
    y2: -658.852
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientTransform: "matrix(1 0 0 -1 1557.068 -6409.493)",
    gradientUnits: "userSpaceOnUse",
    x1: -1091.109,
    x2: -1057.568,
    xlinkHref: "#lg1",
    y1: -6701.329,
    y2: -6701.329
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 482.729,
    x2: 482.729,
    xlinkHref: "#lg2",
    y1: 214.616,
    y2: 148.427
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientTransform: "matrix(.707 -.707 .707 .707 2831.207 -1021.632)",
    gradientUnits: "userSpaceOnUse",
    x1: -2684.046,
    x2: -2708.405,
    xlinkHref: "#lg2",
    y1: -637.203,
    y2: -612.844
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientTransform: "matrix(.707 .707 -.707 .707 388.69 -377.723)",
    gradientUnits: "userSpaceOnUse",
    x1: 360.11,
    x2: 392.415,
    y1: 256.153,
    y2: 288.458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ade194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68ca44"
  }))), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientTransform: "matrix(.707 .707 -.707 .707 388.69 -377.723)",
    gradientUnits: "userSpaceOnUse",
    x1: 375.95,
    x2: 375.95,
    y1: 279.638,
    y2: 302.144
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#017b4e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6867,
    stopColor: "#016f46",
    stopOpacity: 0.687
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026841"
  }))), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientTransform: "matrix(.991 -.133 .133 .991 -29.935 -61.205)",
    gradientUnits: "userSpaceOnUse",
    x1: 362.267,
    x2: 394.573,
    y1: 147.828,
    y2: 180.133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientTransform: "matrix(.991 -.133 .133 .991 -29.935 -61.205)",
    gradientUnits: "userSpaceOnUse",
    x1: 378.107,
    x2: 378.107,
    y1: 171.314,
    y2: 193.819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2442,
    stopColor: "#f12817",
    stopOpacity: 0.244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5941,
    stopColor: "#de281f",
    stopOpacity: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.69,
    x2: 294.859,
    xlinkHref: "#lg3",
    y1: 99.753,
    y2: 238.922
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.875,
    x2: 205.571,
    xlinkHref: "#lg3",
    y1: 260.567,
    y2: 155.263
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.364,
    x2: 195.114,
    y1: 138.579,
    y2: 179.33
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7bacdf",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7bacdf"
  }))), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.684,
    x2: 217.944,
    y1: 158.003,
    y2: 178.264
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe646f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.373,
    x2: 227.381,
    y1: 174.57,
    y2: 188.579
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.447,
    x2: 288.486,
    y1: 88.766,
    y2: 109.806
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9b1ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5127,
    stopColor: "#af66da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8279,
    stopColor: "#814aa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#6f3f8a"
  }))), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 283.373,
    x2: 297.179,
    y1: 105.57,
    y2: 119.377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6f3f8a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6f3f8a"
  }))), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientTransform: "matrix(0 1 1 0 2316.758 -2316.758)",
    gradientUnits: "userSpaceOnUse",
    x1: 2752.335,
    x2: 2810.417,
    xlinkHref: "#lg1",
    y1: -2061.758,
    y2: -2061.758
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 471.403,
    y2: 492.48
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m60.336 118.062c-9.262 0-16.771 7.508-16.771 16.771v157.323c0 3.657 2.964 6.621 6.621 6.621h20.299c3.657 0 6.621-2.964 6.621-6.621v-157.324c.001-9.262-7.508-16.77-16.77-16.77z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.107 232.667h-33.541v59.487c0 3.657 2.964 6.621 6.621 6.621h20.299c3.657 0 6.621-2.964 6.621-6.621z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m125.402 122.062c-9.262 0-16.771 7.508-16.771 16.771v153.323c0 3.657 2.964 6.621 6.621 6.621h20.299c3.657 0 6.621-2.964 6.621-6.621v-153.324c0-9.262-7.508-16.77-16.77-16.77z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.402 122.062c-9.262 0-16.771 7.508-16.771 16.771v3.285l33.541 33.541v-36.826c0-9.263-7.508-16.771-16.77-16.771z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.172 232.667h-33.541v59.487c0 3.657 2.964 6.621 6.621 6.621h20.299c3.657 0 6.621-2.964 6.621-6.621z",
    fill: "url(#SVGID_5_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m27.271 235.228c-9.262 0-16.771 7.508-16.771 16.771v199.823c0 3.657 2.964 6.621 6.621 6.621h20.299c3.657 0 6.621-2.964 6.621-6.621v-199.823c0-9.262-7.508-16.771-16.77-16.771z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.041 392.334h-33.541v59.487c0 3.657 2.964 6.621 6.621 6.621h20.299c3.657 0 6.621-2.964 6.621-6.621z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m92.336 277.728c-9.262 0-16.771 7.508-16.771 16.771v157.323c0 3.657 2.964 6.621 6.621 6.621h20.299c3.657 0 6.621-2.964 6.621-6.621v-157.323c.001-9.262-7.508-16.771-16.77-16.771z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.336 277.728c-9.262 0-16.771 7.508-16.771 16.771v20.902l33.541 33.541v-54.444c.001-9.261-7.508-16.77-16.77-16.77z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.107 392.334h-33.541v59.487c0 3.657 2.964 6.621 6.621 6.621h20.299c3.657 0 6.621-2.964 6.621-6.621z",
    fill: "url(#SVGID_10_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m157.402 281.728c-9.262 0-16.771 7.508-16.771 16.771v153.323c0 3.657 2.964 6.621 6.621 6.621h20.299c3.657 0 6.621-2.964 6.621-6.621v-153.323c0-9.262-7.508-16.771-16.77-16.771z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.402 281.728c-9.262 0-16.771 7.508-16.771 16.771v20.902l33.541 33.541v-54.444c0-9.261-7.508-16.77-16.77-16.77z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.172 392.334h-33.541v59.487c0 3.657 2.964 6.621 6.621 6.621h20.299c3.657 0 6.621-2.964 6.621-6.621z",
    fill: "url(#SVGID_13_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m222.467 239.728c-9.262 0-16.771 7.508-16.771 16.771v195.323c0 3.657 2.964 6.621 6.621 6.621h20.299c3.657 0 6.621-2.964 6.621-6.621v-195.323c.001-9.262-7.508-16.771-16.77-16.771z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.467 239.728c-9.262 0-16.771 7.508-16.771 16.771v20.902l33.541 33.541v-54.444c.001-9.261-7.508-16.77-16.77-16.77z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.238 392.334h-33.541v59.487c0 3.657 2.964 6.621 6.621 6.621h20.299c3.657 0 6.621-2.964 6.621-6.621z",
    fill: "url(#SVGID_16_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m287.533 176.228c-9.262 0-16.771 7.508-16.771 16.771v258.823c0 3.657 2.964 6.621 6.621 6.621h20.299c3.657 0 6.621-2.964 6.621-6.621v-258.823c0-9.262-7.508-16.771-16.77-16.771z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.533 176.228c-9.262 0-16.771 7.508-16.771 16.771v20.902l33.541 33.541v-54.444c0-9.261-7.508-16.77-16.77-16.77z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.303 392.334h-33.541v59.487c0 3.657 2.964 6.621 6.621 6.621h20.299c3.657 0 6.621-2.964 6.621-6.621z",
    fill: "url(#SVGID_19_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m352.598 110.228c-9.262 0-16.771 7.508-16.771 16.771v324.823c0 3.657 2.964 6.621 6.621 6.621h20.299c3.657 0 6.621-2.964 6.621-6.621v-324.823c.001-9.262-7.508-16.771-16.77-16.771z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.598 110.228c-9.262 0-16.771 7.508-16.771 16.771v20.902l33.541 33.541v-54.444c.001-9.261-7.507-16.77-16.77-16.77z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.369 392.334h-33.541v59.487c0 3.657 2.964 6.621 6.621 6.621h20.299c3.657 0 6.621-2.964 6.621-6.621z",
    fill: "url(#SVGID_22_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m417.664 81.228c-9.262 0-16.771 7.508-16.771 16.771v353.823c0 3.657 2.964 6.621 6.621 6.621h20.299c3.657 0 6.621-2.964 6.621-6.621v-353.823c0-9.262-7.508-16.771-16.77-16.771z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417.664 81.228c-9.262 0-16.771 7.508-16.771 16.771v20.902l33.541 33.541v-54.443c0-9.262-7.508-16.771-16.77-16.771z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.434 392.334h-33.541v59.487c0 3.657 2.964 6.621 6.621 6.621h20.299c3.657 0 6.621-2.964 6.621-6.621z",
    fill: "url(#SVGID_25_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m482.729 125.228c-9.262 0-16.771 7.508-16.771 16.771v309.823c0 3.657 2.964 6.621 6.621 6.621h20.299c3.657 0 6.621-2.964 6.621-6.621v-309.823c.001-9.262-7.507-16.771-16.77-16.771z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m482.729 125.228c-9.262 0-16.771 7.508-16.771 16.771v20.902l33.541 33.541v-54.444c.001-9.261-7.507-16.77-16.77-16.77z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m499.5 392.334h-33.541v59.487c0 3.657 2.964 6.621 6.621 6.621h20.299c3.657 0 6.621-2.964 6.621-6.621z",
    fill: "url(#SVGID_28_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m492.394 79.731c-3.89 2.988-9.392 2.628-12.861-.84l-33.587-33.587c-3.909-3.909-10.364-3.487-13.731.897l-15.237 19.84c-3.815 4.967-3.356 11.993 1.073 16.421l42.127 42.127c4.429 4.429 11.454 4.887 16.421 1.073l27.069-20.79c7.759-5.959 8.505-17.383 1.587-24.3-3.468-3.469-8.97-3.829-12.861-.841z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.505 47.126-14.527 18.915c-3.815 4.967-3.356 11.993 1.073 16.421l42.127 42.127c4.429 4.429 11.454 4.887 16.421 1.073l18.915-14.527z",
    fill: "url(#SVGID_30_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m384.356 26.203c.015 4.905-3.608 9.061-8.47 9.715l-47.075 6.327c-5.479.736-9.059 6.124-7.617 11.46l6.529 24.149c1.635 6.046 7.498 9.943 13.705 9.109l59.046-7.936c6.207-.834 10.834-6.141 10.814-12.404l-.107-34.131c-.031-9.783-8.66-17.306-18.356-16.003-4.861.653-8.485 4.809-8.469 9.714z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321.499 54.831 6.225 23.023c1.635 6.046 7.498 9.943 13.705 9.109l59.046-7.936c6.207-.834 10.834-6.141 10.814-12.404l-.075-23.85z",
    fill: "url(#SVGID_32_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m474.713 106.386c-44.982-44.98-118.169-44.978-163.149 0l-69.52 69.521-47.506-47.506c-16.925-16.925-37.94-27.961-60.774-31.917-21.221-3.675-43.146-1.182-63.416 7.214-20.268 8.396-37.538 22.138-49.943 39.741-13.349 18.943-20.405 41.607-20.405 65.543s7.056 46.6 20.404 65.542c12.404 17.603 29.674 31.345 49.942 39.74 14.193 5.879 29.197 8.864 44.204 8.864 6.424 0 12.851-.548 19.212-1.649 22.833-3.956 43.849-14.992 60.775-31.917l150.101-150.102c26.743-26.742 70.257-26.744 97.001 0l38.716 38.716c10.94 10.94 29.646 3.192 29.646-12.279 0-15.51-6.161-30.385-17.128-41.352zm-313.25 150.102c-23.405 23.405-53.167 22.867-73.216 14.564-20.05-8.305-41.474-28.972-41.474-62.071 0-33.098 21.424-53.765 41.474-62.069 7.667-3.176 16.749-5.215 26.359-5.215 15.519 0 32.403 5.324 46.857 19.779l47.507 47.505z",
    fill: "url(#SVGID_33_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m480.354 155.177-38.716-38.716c-26.743-26.744-70.257-26.742-97.001 0l-150.1 150.101c-16.926 16.925-37.941 27.961-60.775 31.917-6.36 1.101-12.787 1.649-19.212 1.649-15.007 0-30.011-2.985-44.204-8.865-20.268-8.395-37.538-22.137-49.942-39.74-11.189-15.877-17.937-34.376-19.834-54.041-.366 3.795-.57 7.628-.57 11.5 0 23.936 7.056 46.6 20.404 65.542 12.404 17.603 29.674 31.345 49.942 39.74 14.193 5.879 29.197 8.865 44.204 8.865 6.424 0 12.852-.548 19.212-1.649 22.833-3.956 43.849-14.992 60.775-31.917l150.101-150.103c26.743-26.742 70.257-26.744 97.001 0l38.716 38.716c10.94 10.94 29.646 3.192 29.646-12.279 0-5.079-.673-10.086-1.947-14.914-5.064 9.692-18.894 12.999-27.7 4.194z",
    fill: "url(#SVGID_34_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m133.764 96.485c-8.691-1.505-17.499-1.958-26.264-1.412v46.994c2.326-.241 4.699-.37 7.106-.37 15.519 0 32.403 5.324 46.857 19.779l47.507 47.505 33.073-33.073-47.506-47.506c-16.924-16.925-37.94-27.962-60.773-31.917z",
    fill: "url(#SVGID_35_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m257.97 159.972v.01l-59.19 59.19h-.01c-.45-.27-.88-.56-1.3-.88l-19.84-15.24c-4.38-3.36-4.8-9.82-.89-13.73l33.58-33.58c3.47-3.47 3.83-8.98.84-12.87-1.36-1.76-2.02-3.86-2.02-5.95 0-1.83.51-3.65 1.52-5.24.38-.59.82-1.15 1.34-1.67 6.92-6.91 18.34-6.17 24.3 1.59l4.81 6.26 15.98 20.81c.32.42.61.85.88 1.3z",
    fill: "url(#SVGID_36_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.97 159.972v.01l-59.19 59.19h-.01c-.45-.27-.88-.56-1.3-.88l-18.91-14.53 64.01-64 14.52 18.91c.32.42.61.85.88 1.3z",
    fill: "url(#SVGID_37_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m328.41 92.462c-5.95 4.02-11.59 8.66-16.85 13.92l-43.28 43.29c-.45-.26-.89-.56-1.31-.88l-19.84-15.24c-4.38-3.36-4.8-9.82-.89-13.73l33.58-33.58c3.47-3.47 3.83-8.98.84-12.87-1.36-1.76-2.02-3.86-2.02-5.95 0-2.51.96-5.01 2.86-6.91 6.92-6.91 18.34-6.17 24.3 1.59l20.79 27.07c.79 1.02 1.39 2.13 1.82 3.29z",
    fill: "url(#SVGID_38_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.41 92.462c-5.95 4.02-11.59 8.66-16.85 13.92l-43.28 43.29c-.45-.26-.89-.56-1.31-.88l-18.91-14.53 64.01-64 14.52 18.91c.79 1.02 1.39 2.13 1.82 3.29z",
    fill: "url(#SVGID_39_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m510 475.577v-21.919c0-9.986-8.095-18.081-18.081-18.081h-473.838c-9.986 0-18.081 8.096-18.081 18.082v21.919c0 9.986 8.095 18.081 18.081 18.081h473.838c9.986 0 18.081-8.096 18.081-18.082z",
    fill: "url(#SVGID_40_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 466.754v8.824c0 9.986 8.095 18.081 18.081 18.081h473.838c9.986 0 18.081-8.095 18.081-18.081v-8.824z",
    fill: "url(#SVGID_41_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRollerCoaster);
export default __webpack_public_path__ + "static/media/icon-roller-coaster.7021f58a65fcf1ac92c7c8762996fa58.svg";
export { ForwardRef as ReactComponent };